import { Platform } from "react-native";

export default Platform.select({
  ios: "977085460082-39j1s084u5qe4spbarkjgrq57q0vc2i2.apps.googleusercontent.com",
  android:
    "977085460082-8rvbrpqq1orhs8q6i6974mn48ek28k6p.apps.googleusercontent.com",
  default:
    "977085460082-sh4lhun06hhf2foa412711euao2rf41n.apps.googleusercontent.com",
});
